var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-header-1"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.updated)?_c('div',{staticClass:"updated-date"},[_vm._v("Last Updated: "+_vm._s(_vm.updated))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }